import React from 'react';

import { IMessage, TRate } from '@sv-support-sdk/shared-types/src/common/chats';

import Divider from '@sv-support-sdk/ui-components/src/components/Content/Divider';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import Message from '../../../components/Content/Message';
import MessageFile from '../../../components/Content/Message/MessageFile';
import MessagePlaceholder from '../../../components/Content/Message/MessagePlaceholder';
import Rating from '../../../components/Feedback/Rating';

import { $l } from '../../../locales';

import css from '../style.module.scss';

interface IProps {
  messages: IMessage[];
  rate: TRate;
}

const Conversation = ({ messages, rate }: IProps) => {
  return (
    <div className={css.conversation}>
      <List indents="16" gap="16" overflow="auto">
        <Divider text={$l('CHAT.CONVERSATION_STARTS')} />
        {messages.map(
          ({ id, message, createdAtToShow, avatar, isFromUser, attachments, reply }) => (
            <Message
              type={isFromUser ? 'fromUser' : undefined}
              offset="8-0"
              key={id}
              avatar={avatar}
              date={createdAtToShow}
              htmlMessage={message}
              replyMessage={reply}
            >
              {!attachments.length
                ? null
                : attachments.map(({ name, size, id, link, extension }) => {
                    return (
                      <MessageFile
                        key={id}
                        link={link}
                        name={name}
                        extraIcon="colored--12--download"
                        subtitle={$l('CHAT.CLICK_TO_DOWNLOAD')}
                        size={String(size)}
                        extension={extension}
                      />
                    );
                  })}
            </Message>
          ),
        )}
        <Divider text={$l('CHAT.CONVERSATION_ENDS')} />
        {rate ? (
          <MessagePlaceholder minHeight="none">
            <Headline type="secondary" fontSize="14">
              {$l('CHAT.RATED_AS')}
            </Headline>
            <Rating rate={rate} viewOnly />
          </MessagePlaceholder>
        ) : null}
      </List>
    </div>
  );
};

export default Conversation;
